import { LoadOptions } from '@lib/components/Select/types';
import {
  filterBySelectedIds,
  getLoadOptionsWithSelectedFilter,
} from '@lib/components/SelectPanel/utils/getLoadOptionsWithSelectedFilter';
import { FieldNames } from '../enums';
import { TasksTableMultiselectFilterLoadOptions } from '../types';

type Loader = (filters?: Array<Record<string, unknown>>) => LoadOptions;

// Wires each app's search-list loaders into the picker's filter row: Sites
// narrow to the picked Sectors, Areas to the picked Sites.
export default function buildFilterLoadOptions(loaders: {
  loadSectors: Loader;
  loadSites: Loader;
  loadSiteAreas: Loader;
  loadEquipment: Loader;
  loadFormCategories: Loader;
}): TasksTableMultiselectFilterLoadOptions {
  return {
    getSectorsLoadOptions: getLoadOptionsWithSelectedFilter(
      loaders.loadSectors,
    ),
    getSitesLoadOptions: getLoadOptionsWithSelectedFilter(
      loaders.loadSites,
      filterBySelectedIds(FieldNames.Sectors, 'sectorId'),
    ),
    getSiteAreasLoadOptions: getLoadOptionsWithSelectedFilter(
      loaders.loadSiteAreas,
      filterBySelectedIds(FieldNames.Sites, 'siteId'),
    ),
    getEquipmentLoadOptions: getLoadOptionsWithSelectedFilter(
      loaders.loadEquipment,
    ),
    getFormCategoriesLoadOptions: getLoadOptionsWithSelectedFilter(
      loaders.loadFormCategories,
    ),
  };
}
